import inflection from 'inflection';

import { range } from '@buyside/util/lodashAlt';

const { rankingCategories } = require('buyside/util/constantsFromRails.json');

export const formatCategory = (category: string): string => {
  let formattedCategory = category.replace(/_/g, ' ');
  if (formattedCategory === 'general') {
    formattedCategory = 'All Time';
  }
  if (formattedCategory === 'growth at reasonable price') {
    formattedCategory = 'GARP';
  }
  if (formattedCategory === 'last twelve months') {
    formattedCategory = 'LTM';
  }
  return inflection.titleize(formattedCategory);
};

export const formatCategoryLabel = (category: string): string => {
  let categoryLabel = formatCategory(category);

  if (category === 'last_twelve_months') {
    categoryLabel = 'Last Twelve Months (LTM)';
  } else if (category === 'growth_at_reasonable_price') {
    categoryLabel = 'Growth At Reasonable Price';
  }

  return categoryLabel;
};

export const RANKING_SECTIONS = Object.freeze([
  {
    title: 'Overall',
    categories: range([0, 2]).map(idx => rankingCategories[idx])
  },
  {
    title: 'Market Cap',
    categories: range([2, 6]).map(idx => rankingCategories[idx])
  },
  {
    title: 'Sector',
    categories: range([6, 14]).map(idx => rankingCategories[idx])
  },
  {
    title: 'Direction',
    categories: range([14, 16]).map(idx => rankingCategories[idx])
  },
  {
    title: 'Investment Situation',
    categories: range([16, 20]).map(idx => rankingCategories[idx])
  },
  {
    title: 'Region',
    categories: range([20, 23]).map(idx => rankingCategories[idx])
  }
]);
